// extracted by mini-css-extract-plugin
export default {"container":"dQ_g","image":"dQ_dx","title":"dQ_cX","quarter":"dQ_m8","label":"dQ_mq"};